import CommonButton from "../../../../../components/common/commonButton/CommonButton";
import Icon1 from '../../../../../assets/images/icon1.png';
import Icon2 from '../../../../../assets/images/icon2.png';
import Icon3 from '../../../../../assets/images/icon3.png';
import Icon4 from '../../../../../assets/images/icon4.png';
import { Link } from "react-router-dom";
import CommonInput from "../../../../../components/ui/commonInput/CommonInput";
import CoinImg from '../../../../../assets/images/btc.png';
const StepOne = ({ onNext }: { onNext: () => void }) => {
    const logos = [
        { id: 1, src: Icon1 },
        { id: 2, src: Icon2 },
        { id: 3, src: Icon3 },
        { id: 4, src: Icon4 }
    ];
    return (
        <>
            <CommonInput
                label="You Stake"
                coin={CoinImg}
                coinName="BTC"
                placeholder="0"
                rightBtnTitle="MAX"
            />
            <CommonButton title="Stake directly, from anywhere" fluid onClick={onNext} />
            <div className="stake_or"><span>or use Bitcoin wallet</span></div>
            <div className="stake_wallets">
                {logos.map(logo => (
                    <Link to="#" className="stake_wallets_icon" key={logo.id}>
                        <img src={logo.src} alt="Icon" />
                    </Link>
                ))}
            </div>
        </>
    );
};
export default StepOne;
